<template>
    <div class="content">
        <h3 ref="pageHeader" class="pageHeader">安全课程资料管理</h3>
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
                <el-form-item label="组织结构">
                    <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell"
                        @handleOrganQuery="handleOrganQuery1">
                    </OrganDialog>
                    <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1"
                        @clear="handeleClear1" clearable></el-input>
                </el-form-item>
                <el-form-item label="资料标题">
                    <el-input v-model="formInline.title" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="文件类型">
                    <el-select v-model="formInline.extension" clearable placeholder="请选择" style="width:216px;">
                        <el-option v-for="(item, index) in $store.state.extensions" :key="index" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="安全类型">
                    <el-select v-model="formInline.safe_level" clearable placeholder="请选择" style="width:216px;">
                         <el-option v-for="(item, index) in $store.state.dangerCategorys" :key="index" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="来源">
                    <el-select v-model="formInline.source" clearable placeholder="请选择" style="width:216px;">
                        <el-option v-for="(item, index) in $store.state.materialSources" :key="index" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="formInline.status" clearable placeholder="请选择" style="width:216px;">
                        <el-option v-for="item in $store.state.courseResourceStatus" :key="item.value"
                            :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleQuery">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd(() => initVideoUpload())">新增课程资料</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <custom-table :data="tableData" border style="width: 100%">
                <custom-table-column fixed label="序号" type="index" width="50">
                </custom-table-column>
                <custom-table-column fixed prop="title" label="资料标题" min-width="180">
                </custom-table-column>
                <custom-table-column prop="status_desc" label="状态" width="90">
                </custom-table-column>
                <custom-table-column prop="total_time" label="时长（秒）/页数" width="140">
                </custom-table-column>
                <custom-table-column prop="extension" label="文件类型" width="160">
                </custom-table-column>
                <custom-table-column label="资料" min-width="220">
                    <template slot-scope="scope" v-if="scope.row.content">
                        <el-link type="primary" v-for="(item, index) in scope.row.content.split(',')"
                            @click="handleVideoClick(item)" :key="index">{{ decodeURIComponent($until.getFileName(item))
                            }}</el-link>
                    </template>
                </custom-table-column>
                <custom-table-column prop="" label="所属组织结构" min-width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 ? '-' + scope.row.structure_2 : ''
                        }}</span>
                    </template>
                </custom-table-column>
                <custom-table-column prop="safe_level" label="安全类型" width="110">
                </custom-table-column>
                <custom-table-column prop="source" label="来源" width="110">
                </custom-table-column>
                <custom-table-column fixed="right" label="操作" width="160">
                    <template slot-scope="scope">
                        <!-- <el-button @click="detailMethod(scope.row, 'view')" type="text" size="small">查看详情</el-button> -->
                        <template v-if="scope.row.source == '用户上传'|| isAdmin">
                            <el-button @click="detailMethod(scope.row, 'edit')" type="text" size="small">编辑</el-button>
                            <el-button v-if="scope.row.status == 0" @click="handlePublish(scope.row)" type="text"
                                size="small">发布</el-button>
                            <el-button @click="handleStatusDelete(scope.row)" type="text" size="small">作废</el-button>
                            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
                        </template>
                    </template>
                </custom-table-column>
            </custom-table>
            <div class="pageLine">
                <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="type == 'view'" label-width="120px"
                :class="`demo-ruleForm ${type == 'view' ? 'view-form' : ''}`">
                <el-form-item label="资料标题" prop="title">
                    <el-input v-model="ruleForm.title" placeholder="请输入" clearable style="width:552px;"></el-input>
                </el-form-item>
                <!-- <el-form-item label="安全课程" prop="course_id">
                    <el-select v-model="ruleForm.course_id" clearable filterable remote :remote-method="getCourseList"
                        :loading="loading1" placeholder="输入课程名称搜索" style="width:216px;">
                        <el-option v-for="item in courseList" :key="item.id" :label="item.title" :value="item.id">
                            <p>{{ item.title }}</p>
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="所属组织结构" prop="structure_1">
                    <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell"
                        @handleOrganQuery="handleOrganQueryNew({ limit: false, major: 'structure_2' })">
                    </OrganDialog>
                    <el-input v-model="selectName" placeholder="请选择" style="width:552px;" @focus="dialogOpen"
                        @clear="handeleClear" clearable></el-input>
                </el-form-item>
                <el-form-item label="安全类型" prop="safe_level">
                    <el-select v-model="ruleForm.safe_level" clearable placeholder="请选择" style="width:216px;">
                        <el-option v-for="item in $store.state.dangerCategorys" :key="item" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="来源" prop="source">
                    <el-select v-model="ruleForm.source"
                        :disabled="!isAdmin"
                        clearable placeholder="请选择" style="width:216px;">
                        <el-option v-for="(item, index) in $store.state.materialSources" :key="index" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="资料文件" prop="content">
                    <div style="width:342px;">
                        <VideoUpload ref="videoUpload" @setFormValForKey="setFormValForKey"
                            @setFormTimeForKey="setFormTimeForKey"></VideoUpload>
                    </div>
                </el-form-item>
                <el-form-item style="margin-top:8px;width:100%;text-align:right;" v-if="type != 'view'">
                    <el-button type="primary" v-if="type == 'add'"
                        @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
                    <el-button type="primary" v-if="type == 'edit'"
                        @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
                    <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
            <span>是否删除</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteMethod">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 视频预览 -->
        <el-dialog :close-on-click-modal="false" title="视频预览" :visible.sync="innerVideoDialogVisible" width="900px"
            @closed="stopPreviewVideo">
            <div style="text-align:center;">
                <video ref="previewVideo" :src="videoSrc"
                    style="width:100%;max-height:68vh;display:block;margin:0 auto;" controls
                    controlslist="nodownload noremoteplayback" disablepictureinpicture
                    @contextmenu.prevent="onVideoContextMenu" @ratechange="lockPlaybackRate"></video>
            </div>
        </el-dialog>
        <!-- 资料预览(PDF) -->
        <el-dialog :close-on-click-modal="false" title="资料预览" :visible.sync="pdfPreviewVisible" width="900px">
            <div v-loading="!pdfSrc || !pdfTotalPages" style="min-height:120px;">
                <div :style="{
                    width: pdfScaleW ? pdfScaleW + 'px' : '100%',
                    margin: '0 auto',
                    overflow: 'hidden',
                    boxSizing: 'border-box'
                }">
                    <pdf v-if="pdfSrc && pdfTotalPages" :key="pdfPreviewKey" :src="pdfSrc" :page="pdfCurPage"
                        @page-size="onPdfPageSize" style="display:block;width:100%;border:1px solid #ebeef5;"></pdf>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div style="text-align:center;">
                    <el-button :disabled="pdfCurPage <= 1" @click="pdfCurPage--">上一页</el-button>
                    <span style="margin:0 16px;">{{ pdfCurPage }} / {{ pdfTotalPages }}</span>
                    <el-button :disabled="pdfCurPage >= pdfTotalPages" @click="pdfCurPage++">下一页</el-button>
                </div>
            </span>
        </el-dialog>
        <OrganDialog ref="organDia"></OrganDialog>
    </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinVideoUpload } from '@/assets/js/mixin/videoupload';
import pdf from 'vue-pdf';

export default {
    name: 'courseMaterialsManage',
    mixins: [mixinList, mixinOrgan, mixinVideoUpload],
    components: {
        pdf,
    },
    data() {
        return {
            formInline: {
                title: '',
                extension: '',
                safe_level: '',
                source: '',
                status: '',
                structure_1: '',
                structure_2: '',
            },
            levell: [1, 2],
            selectName: '',
            organLabel: '',
            courseList: [],
            loading1: false,
            // 视频/PDF 上传(参考 safeCourse):上传后自动写入 content / key / size / total_time
            vfileFormName: 'ruleForm',
            vfileFieldName: 'content',
            ruleForm: {
                title: '',
                // course_id: '',
                safe_level: '',
                source: '用户上传',
                structure_1: '',
                structure_2: '',
                content: '',
                key: '',
                size: '',
                total_time: '',
            },
            rules: {
                title: [{ required: true, message: '请输入', trigger: 'blur' }],
                safe_level: [{ required: true, message: '请选择', trigger: 'change' }],
                // source: [{ required: true, message: '请选择', trigger: 'change' }],
                // structure_1: [{ required: true, message: '请选择' }],
                content: [{ required: true, message: '请上传', trigger: 'change' }],
            },
            // 资料预览(视频 / PDF)
            innerVideoDialogVisible: false,
            videoSrc: '',
            pdfPreviewVisible: false,
            pdfSrc: '',
            pdfTotalPages: 0,
            pdfCurPage: 1,
            pdfRatio: 0.7071, // 页面宽高比(竖版 A4 默认,page-size 事件到后更新)
            pdfScaleW: 0, // 按视口可用高度算出的整页宽度(整页显示,不出现滚动条)
            pdfPreviewKey: 0, // pdf 组件重建 key(切换资料时强制新建实例,避免 vue-pdf 复用加载失败)
        };
    },
    beforeDestroy() {
        // 释放 PDF 的 blob 地址
        if (this._pdfObjUrl) URL.revokeObjectURL(this._pdfObjUrl)
    },
    computed: {
        isAdmin() {
            return (this.$store.state.userInfo && (this.$store.state.userInfo.number == 'xsadmin' || this.$store.state.userInfo.number == 'admin'));
        },
    },
    mounted() {
        this.$store.dispatch('getDangerCategorys');
    },
    methods: {
        // ===== 资料预览:pdf 走 pdf 预览,其余按视频播放 =====
        handleVideoClick(src) {
            const lower = String(src || '').toLowerCase()
            if (/\.pdf(\?|#|$)/.test(lower)) {
                this.openPdfPreview(src)
            } else {
                this.innerVideoDialogVisible = true;
                this.videoSrc = src;
            }
        },
        // 视频:禁止右键(拦截"视频另存为/下载"等浏览器菜单)
        onVideoContextMenu(e) {
            e.preventDefault()
        },
        // 视频:锁定 1 倍速(ratechange 时强制复位)
        lockPlaybackRate() {
            const el = this.$refs.previewVideo
            if (el && el.playbackRate !== 1) el.playbackRate = 1
        },
        // 关闭预览时停止播放,避免后台继续播
        stopPreviewVideo() {
            const el = this.$refs.previewVideo
            if (el && !el.paused) el.pause()
        },
        async openPdfPreview(url) {
            this.pdfCurPage = 1
            this.pdfTotalPages = 0
            this.pdfSrc = '' // 先卸载旧 pdf 组件
            this.pdfScaleW = 0
            this.pdfPreviewVisible = true
            try {
                // 每次都手动请求文件,转成本地 Blob URL 再交给 vue-pdf,避免其内部对直链的缓存/复用导致切换不加载
                const resp = await fetch(url)
                if (!resp.ok) throw new Error('HTTP ' + resp.status)
                const blob = await resp.blob()
                if (this._pdfObjUrl) URL.revokeObjectURL(this._pdfObjUrl)
                const objectUrl = URL.createObjectURL(blob)
                this._pdfObjUrl = objectUrl
                const task = pdf.createLoadingTask(objectUrl)
                const pdfDoc = await task.promise
                this.pdfTotalPages = pdfDoc.numPages || 1
                this.pdfScaleW = this.calcPdfWidth(this.pdfRatio)
                this.pdfCurPage = 1
                this.pdfPreviewKey++ // 全新 key 挂载新实例,只加载一次
                this.pdfSrc = objectUrl
            } catch (e) {
                this.$message.error('PDF 加载失败，请确认文件格式')
                this.pdfPreviewVisible = false
            }
        },
        // pdf 渲染后回调:更新页面宽高比并重算显示宽度(整页适配,不出现滚动条)
        onPdfPageSize(width, height) {
            if (width && height) {
                this.pdfRatio = width / height
                this.pdfScaleW = this.calcPdfWidth(this.pdfRatio)
            }
        },
        // 按可用高度计算整页宽:页面完整呈现,高度不超过弹窗可用区域(底部为翻页条)
        calcPdfWidth(ratio) {
            const winH = (window.innerHeight || 800)
            const winW = (window.innerWidth || 1280)
            // 可用高度:视口 - 弹窗头部/底部按钮条/外边距
            const availH = Math.max(320, winH - 240)
            // 最大宽度:弹窗 900 内容约 860,再受视口宽限制
            const maxW = Math.min(860, winW - 80)
            const w = Math.min(maxW, availH * (ratio || 0.7071))
            return Math.max(280, Math.round(w))
        },
        // ===== 列表 =====
        handleQuery() {
            this.beforeQueryByKeyNew({ dep: 'structure_1', major: 'structure_2', formK: 'formInline' });
            this.$refs.pageChild.page = 1;
            this.getList();
        },
        async getList() {
            let params = this.$until.deleteNullPrototype(this.formInline);
            params.page = this.$refs.pageChild.page;
            params.size = this.$refs.pageChild.size;
            let res = await this.$api.instance.interfaceServer('api/new_course_resources/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
        detailMethod(row, type) {
            if (type == 'view') {
                // 查看详情直接从列表数据取,不调接口(列表数据已含全部字段)
                this.handleDetailNew(row);
                this.handleEditCallBackSetStruc({ row: row });
                this.initVideoUpload(row);
                return;
            }
            // 编辑也从列表数据取,不调接口(列表数据已含全部字段)
            this.handleEditNew(row);
            this.handleEditCallBackSetStruc({ row: row });
            this.initVideoUpload(row);
            // 课程下拉回显:courseList 中无当前课程时补一条
            // if (row.course_id && JSON.stringify(this.courseList).indexOf(row.course_id) == -1) {
            //     this.courseList.push({ id: row.course_id, title: row.course_name || '' });
            // }
        },
        // 初始化上传组件:有已上传文件就回显,否则回到待选择状态
        // (弹窗常驻不销毁,不重置会残留上一次选中的文件)
        initVideoUpload(row) {
            this.$nextTick(() => {
                let upload = this.$refs.videoUpload;
                if (!upload) return;
                upload.currentFile = null;
                upload.isNeedUp = true;
                upload.isUploading = false;
                upload.aborted = false;
                upload.checkpoint = null;
                if (upload.$refs.vupload) upload.$refs.vupload.clearFiles();
                upload.progress = {
                    percent: 0,
                    visible: false,
                    text: '等待用户点击上传...',
                    status: null,
                };
                // 回显:文件名取 key、大小取 size,标记为已上传成功(不显示"点击上传"按钮)
                if (row && row.content) {
                    upload.currentFile = {
                        name: row.key,
                        size: row.size,
                    };
                    upload.isNeedUp = false;
                    upload.progress = {
                        percent: 100,
                        visible: true,
                        text: '上传成功',
                        status: 'success',
                    };
                }
            });
        },
        async getCourseList(query) {
            this.loading1 = true;
            let res = await this.$api.instance.interfaceServer('api/new_course/list', 'get', { title: query, page: 1, size: 10, post: 1 });
            this.loading1 = false;
            if (res.code == 0 && res.data) {
                this.courseList = res.data.data;
            }
        },
        async createMethod() {
            let params = this.$until.deleteNullPrototype(this.ruleForm);
            let res = await this.$api.instance.interfaceServer('api/new_course_resources/add', 'post', params);
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '提交成功！',
                });
                this.clearState();
            }
        },
        async updateMethod() {
            let params = this.$until.easyDeepCopy(this.ruleForm);
            let res = await this.$api.instance.interfaceServer('api/new_course_resources/save', 'post', params);
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '编辑成功！',
                });
                this.clearState();
            }
        },
        statusDeleteMethod(id) {
            this.$api.instance.interfaceServer('api/new_course_resources/statusDelete', 'post', { id: id }).then(res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        center: true,
                        message: '作废成功！',
                    });
                    this.handleQuery();
                }
            });
        },
        handleStatusDelete(row) {
            this.confirmBox('warning', '是否作废该课程资料？', row.id, this.statusDeleteMethod);
        },
        publishMethod(id) {
            this.$api.instance.interfaceServer('api/new_course_resources/statusUpdate', 'post', { id: id }).then(res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        center: true,
                        message: '发布成功！',
                    });
                    this.handleQuery();
                }
            });
        },
        handlePublish(row) {
            this.confirmBox('success', '是否发布该课程资料？', row.id, this.publishMethod);
        },
        async deleteMethod() {
            let res = await this.$api.instance.interfaceServer(`api/new_course_resources/delete/${this.delid}`, 'DELETE');
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '删除成功！',
                });
                this.dialogVisible = false;
                this.handleQuery();
            }
        },
    },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
    width: var(--width);
}
</style>
